import { createSelector } from 'reselect';

import getMember from './getMember';
import { getCardSets } from './config';

export default createSelector(
  [getMember, getCardSets],
  (member, cardsets): Cardset | undefined => {
    if (!member || !cardsets) {
      return undefined;
    }

    return cardsets[member.cardsetId];
  },
);
